complete_handler = {

    properties: {
    },

    onLoad: function(){
        var self = this;

        $('#content-root, #map').removeClass('swipe');
        $('#content-root').addClass('large grey-bg');


    },


    events: function() {
        var self = this;
        self.onLoad();

    }
}